import './Hero.css';

export function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero__content">
        <p className="hero__eyebrow">Vertrouwde Goudaankoop — België</p>
        <h1 className="hero__title">
          Wij Kopen Uw<br />
          <span className="hero__title--gold">Goud &amp; Edelmetalen</span><br />
          tegen een Eerlijke Prijs
        </h1>
        <p className="hero__subtitle">
          Wij kopen aan, wij verkopen niet. Goud, zilver, platina &amp; palladium tegen
          transparante aankoopprijzen op basis van de live spotkoers.
        </p>
        <div className="hero__actions">
          <a href="#prices" className="btn btn--primary">Bekijk Aankoopprijzen</a>
          <a href="#products" className="btn btn--secondary">Wat Wij Kopen</a>
        </div>
      </div>
      <div className="hero__badge-row">
        <div className="hero__badge">🔒 Veilige Transacties</div>
        <div className="hero__badge">📊 Transparante Aankoopprijzen</div>
        <div className="hero__badge">💶 Directe Uitbetaling</div>
      </div>
    </section>
  );
}
